import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/about-banner.jpg';
import floorplanBanner from '../assests/img/floorplan-2025.jpg';
import { Helmet } from 'react-helmet-async';

function Floorplan() {
return (
    <div >
       <Helmet>
                          <title>ISJS 2025 Exhibition Floorplan – Stall Layout & Hall Map</title>
                          <meta
                            name="description"
                            content="Explore the ISJS 2025 exhibition floorplan with hall layout, booth locations, and exhibitor zones for India’s leading jewellery & gemstones show."
                          />
                          <meta
                name="keywords"
                content="ISJS floorplan, jewellery show stall map, exhibition hall layout India, gemstone exhibition map, ISJS booth plan"
              />
                        </Helmet>
    
    <Header/>
    {/* <Showlist/> */}
    <div className='container'>
        <div className='about-banner'>
            <img src={aboutBanner} alt=""/>
        </div>
    </div>
    
    <div className='container main-contant'>
      <div className='inner-page-container'>
        <h1 className='page-title'>Floorplan</h1>

        {/* <div className='col-md-6'>


        </div>

        <div className='col-md-6'>


        </div> */}

        <img src={floorplanBanner} className='floorplan-banner' alt=""/>
      
      </div>
    
    </div>
    <Footer/>
     </div>
    )
}

export default  Floorplan;
